import { z } from 'zod';

import { PaymentDueId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const EditManualStatementEvent = BaseLoanEvent.extend({
  type: z.literal('editManualStatement'),
  principal: z.number(),
  interest: z.number(),
  escrow: z.number(),
  paymentDueId: PaymentDueId,
});
export type EditManualStatementEvent = z.infer<typeof EditManualStatementEvent>;
